import { Project } from "~/application/types";
import { ProjectDTO } from "../dtos";
import { mapShortApprovalModelDTO } from "./mapApprovalModelDTO";

export const mapProjectDTO = (data: ProjectDTO): Project => {
  return {
    uuid: data.uuid,
    name: data.name,
    originalName: data.original_name,
    code: data.code,
    customerId: data.customer_uuid,
    active: data.active,
    approvalModels: data.approval_models?.map(mapShortApprovalModelDTO),
  };
};
